export type ImageSize = 'small' | 'medium' | 'large';

export const DEFAULT_RELEASE_COVER = '/images/254albumdefault.png';

const SIZE_SUFFIX: Record<ImageSize, string> = {
  small: 'sm',
  medium: 'md',
  large: 'lg',
};

export function getImageVariant(url: string | null | undefined, size: ImageSize): string | null {
  if (!url) {
    return null;
  }

  const [baseWithHash, query = ''] = url.split('?');
  const [base, hash = ''] = baseWithHash.split('#');
  const dotIndex = base.lastIndexOf('.');
  if (dotIndex === -1) {
    return url;
  }

  const name = base.slice(0, dotIndex);
  if (name.endsWith('_sm') || name.endsWith('_md') || name.endsWith('_lg')) {
    return url;
  }

  const suffix = SIZE_SUFFIX[size];
  const withSuffix = `${name}_${suffix}${base.slice(dotIndex)}`;
  const withHash = hash ? `${withSuffix}#${hash}` : withSuffix;
  return query ? `${withHash}?${query}` : withHash;
}

export function getDefaultReleaseCover(size: ImageSize): string {
  return getImageVariant(DEFAULT_RELEASE_COVER, size) ?? DEFAULT_RELEASE_COVER;
}
